import { useEffect } from 'react';

// Libs
import { Route, Switch, Redirect } from 'react-router-dom';

// Pages
import HomeView from './views/home/home';
import TrackView from './views/track/track';

// Utils
import { setTheme } from './utils/theme-changer';

import './App.scss';

function App() {
	useEffect(() => {
		setTheme('dark');
	}, []);

	return (
		<div className="App">
			<Switch>
				<Route path="/" exact component={HomeView} />
				<Route path="/track/:id" exact component={TrackView} />
				<Redirect to="/" />
			</Switch>
		</div>
	);
}

export default App;
